import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

interface RefreshButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  loading?: boolean;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  onClick,
  title = "Refresh",
  disabled = false,
  loading = false
}) => {
  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          onClick={onClick}
          disabled={disabled || loading}
          aria-label="refresh"
        >
          <RefreshIcon
            sx={{
              color: "#192f67",
              transition: "transform 0.3s ease",
              transform: loading ? "rotate(180deg)" : "none"
            }}
          />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default RefreshButton;
